<template>
    <div>
        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>รหัสวัตถุดิบ</label>
            </b-col>
            <b-col sm="6">
                <input class="form-control"
                       type="text"
                       v-model="checklist_data.material.code"
                       disabled
                />
            </b-col>
        </b-row>
        <br>
        <b-row sm="10" v-if="checklist_data.material">
            <b-col sm="4" class="col text-right">
                <label>ราคา</label>
            </b-col>
            <b-col sm="6">
                <input class="form-control"
                       type="number"
                       v-model="checklist_data.material.price"
                       disabled
                />
            </b-col>
        </b-row>
        <br>
        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>สั่งซื้อจำนวน</label>
            </b-col>
            <b-col sm="6">
                <input class="form-control"
                       type="number"
                       v-model="quantity"
                />
            </b-col>
        </b-row>
        <br>
        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>สั่งซื้อจาก</label>
            </b-col>
            <b-col sm="6">
                <multiselect
                        v-model="vendor"
                        :options="optionVendor"
                        label="name"
                        placeholder="เลือกผู้จัดจำหน่าย"
                        track-by="name">
                </multiselect>
            </b-col>
        </b-row>
        <br>
        <b-row>
            <div class="col text-center">
                <button @click="saveToPreOrder"
                        type="button"
                        class="btn btn-success">
                    <icon name="save" style="width: 25px"></icon> บันทึก</button>&nbsp&nbsp
                <button type="button"
                        @click="cancelSubmit"
                        class="btn btn-danger">
                    <icon name="times" style="width: 25px"></icon> ยกเลิก
                </button>
            </div>
        </b-row>
        <br>
        <!--<pre class="alert alert-primary">{{ checklist_data }}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import Multiselect from "vue-multiselect";
    import moment from "moment";

    export default {
        name: "check-list-modal",
        components:{Multiselect},
        data(){
          return {
              quantity : 0,
              vendor : "",
              currentDate : ""
          }
        },
        created(){
            this.$store.dispatch('Vendor/getVendorAll');
            this.getCurrentDate();
        },
        computed:{
            ...mapState({
                checklist_data:state=>{
                    return state.CheckList.show_checklist;
                },
                optionVendor:state=>{
                    return state.Vendor.vendorList;
                },
                user: state => {
                    return state.Auth.user;
                },
            })
        },
        methods:{
            saveToPreOrder(){
                let data ={
                    material_id : this.checklist_data.material_id,
                    material_code : this.checklist_data.material.code,
                    quantity : this.quantity,
                    user_id : this.user.id,
                    price : this.checklist_data.material.price,
                    vendor_id : this.vendor.id,
                    date : this.currentDate,
                    status : 1
                };
                if(!this.vendor){
                    alert('กรุณาเลือกผู้จำหน่าย')
                }else{
                    this.$emit("submit", data);
                }
            },
            cancelSubmit(){
                this.$emit("submit", "cancel");
            },
            getCurrentDate(){
                const currentDate = moment().format("YYYY-MM-DD");
                this.currentDate = currentDate;
            }
        }
    }
</script>

<style scoped>

</style>